<template>
  <div class="limit-container" v-if="visible === false || visible === null" v-loading="visible === null">
    <div class="limit-container-inner"  v-if="visible === false">
      <img src="../../../../static/img/noAauthority.png" alt="" class="limit-img">
      <span class="limit-text" v-if="limitCode == 20204">
        {{ $t('speechcraft.limit') }}
      </span>
      <span class="limit-text" v-if="limitCode == 99999">
        {{ $t('speechcraft.menulimit', [$route.meta.title]) }}
      </span>

      <span class="limit-text" v-if="limitCode == 20207">
        {{ $t('speechcraft.sonlimit') }}
      </span>
      <span class="limit-text" v-if="limitCode == 20208">
        {{ $t('speechcraft.rolelimit') }}
      </span>
      <span class="limit-dis" v-if="limitCode == 20204">
        {{ $t('merge.limitProblem') }}
      </span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    limitCode: {
      type: [String,Number],
      default: null
    }
  },
  name: 'limit',
  data() {
    return {
      tip: this.$t('speechcraft.limit'),
      // menuMap: {
      //   resource: this.$t('menu.resource'),
      //   ticket: this.$t('menu.ticket'),
      //   monitor: this.$t('menu.monitor'),
      //   alarm: this.$t('menu.alarm'),
      //   consumption: this.$t('menu.consumption')
      // }

    };
  }
};
</script>
<style lang="sass">
  @import "./limit"
</style>



// WEBPACK FOOTER //
// src/components/common/limit/Limit.vue